<template>
  <j-modal :title="displayTitle" :width="800" :visible="visible" :confirmLoading="confirmLoading"
    :maskClosable="false" :body-style="{ height: '480px', overflow: 'hidden', overflowY: 'scroll' }" @ok="handleOk"
    @cancel="handleCancel" :okText="$t('确定')" :cancelText="$t('关闭')" :okButtonProps="{ class:{'jee-hidden': disableSubmit} }">
    <a-spin :spinning="confirmLoading">
      <j-form-container :disabled="disableSubmit">
        <a-form-model ref="form" :model="model" :rules="validatorRules" slot="detail" :colon="false">
          <a-row :gutter="24">
            <a-col :span="8">
              <a-form-model-item :label="$t('用户水表编号')" prop="userMeterId">
                <a-input v-model="model.userMeterId" :placeholder="$t('请输入用户水表编号')" :disabled="title == '回访'"></a-input>
              </a-form-model-item>
            </a-col>
            <a-col :span="8">
              <a-form-model-item :label="$t('用户手机号')" prop="userPhone">
                <a-input v-model="model.userPhone" :placeholder="$t('请输入用户手机号')" :disabled="title == '回访'"></a-input>
              </a-form-model-item>
            </a-col>
            <a-col :span="8">
              <a-form-model-item :label="$t('来电人员名称')" prop="callerName">
                <a-input v-model="model.callerName" :placeholder="$t('请输入来电人员名称')" :disabled="title == '回访'"></a-input>
              </a-form-model-item>
            </a-col>
            <a-col :span="8" >
              <a-form-model-item :label="$t('来电时间')" prop="callerTime">
                <a-date-picker show-time v-model="model.callerTime" valueFormat="YYYY-MM-DD HH:mm:ss" style="width: 100%" :disabled="title == '回访'"/>
              </a-form-model-item>
            </a-col>
            <a-col :span="8">
              <a-form-model-item :label="$t('接线人员名称')" prop="hotlineStaffId">
                <a-select v-model="model.hotlineStaffId" :placeholder="$t('请选择接线人员名称')" @change="hotlineStaffChange" :disabled="title == '回访'">
                  <a-select-option v-for="item in candidateUsersList" :value="item.id" :key="item.id">{{item.hotlineStaffName}}</a-select-option>
                </a-select>
              </a-form-model-item>
            </a-col>
            <a-col :span="8">
              <a-form-model-item :label="$t('咨询类型')" prop="consultType">
                <a-select v-model="model.consultType" :placeholder="$t('请选择咨询类型')" :disabled="title == '回访'">
                  <a-select-option :value="0">{{ $t('营收类') }}</a-select-option>
                  <a-select-option :value="1">{{ $t('工单类') }}</a-select-option>
                </a-select>
              </a-form-model-item>
            </a-col>
            <a-col :span="24">
              <a-form-model-item :label="$t('咨询信息')" prop="consultMessage">
                <a-textarea v-model="model.consultMessage" :placeholder="$t('请输入咨询信息')" :rows="4" :disabled="title == '回访'"/>
              </a-form-model-item>
            </a-col>
            <template v-if="title == '回访'">
              <a-col :span="8">
                <a-form-model-item :label="$t('是否回访')" prop="isCallback">
                  <a-radio-group v-model="model.isCallback">
                    <a-radio :value="0">{{ $t('否') }}</a-radio>
                    <a-radio :value="1">{{ $t('是') }}</a-radio>
                  </a-radio-group>
                </a-form-model-item>
              </a-col>
              <a-col :span="8" v-if="model.isCallback == 1">
                <a-form-model-item :label="$t('回访时间')" prop="callbackTime">
                  <a-date-picker show-time v-model="model.callbackTime" valueFormat="YYYY-MM-DD HH:mm:ss" style="width: 100%" />
                </a-form-model-item>
              </a-col>
              <a-col :span="8" >
                <a-form-model-item :label="$t('用户满意度')" prop="satisfaction">
                  <a-select v-model="model.satisfaction" :placeholder="$t('请选择用户满意度')" :disabled="title == '回访'">
                    <a-select-option :value="1">{{ $t('营收类') }}</a-select-option>
                    <a-select-option :value="1">{{ $t('工单类') }}</a-select-option>
                  </a-select>
                </a-form-model-item>
              </a-col>
            </template>
          </a-row>
        </a-form-model>
      </j-form-container>
    </a-spin>
  </j-modal>
</template>

<script>
  import {
    httpAction,
    getAction,
    postAction
  } from '@/api/manage'
  import {
    validateDuplicateValue
  } from '@/utils/util'
  import JImageUpload from '@/components/jeecg/JImageUpload.vue'
  export default {
    name: 'modal',
    components: {
      JImageUpload
    },
    data() {
      let validateRemark = (rule, value, callback) => {
        if(this.model.audit == 0){
          if(value){
            callback();
          }else{
            callback(new Error(this.$t('请输入备注')));
          }
        }else{
          callback();
        }
      };
      return {
        title: '',
        width: 800,
        visible: false,
        disableSubmit: false,
        confirmLoading: false,
        model: {},
        url: {
          userList: "/jeecg-hotline/hotlinestaff/hotlineStaffMessage/list",
          add: '/jeecg-hotline/caller/callerHistory/add',
          edit: '/jeecg-hotline/caller/callerHistory/edit',
        },
        candidateUsersList: [],
      }
    },
    watch:{},
    // i18n：校验规则/标题使用 computed 以响应语言切换
    computed: {
      displayTitle() {
        return this.title ? this.$t(this.title) : '';
      },
      validatorRules() {
        return {
          userMeterId:{ required: true,message: this.$t('请输入用户水表编号'), trigger: 'input' },
          userPhone:{ required: true,message: this.$t('请输入用户手机号'), trigger: 'input' },
          // callerName:{ required: true,message: '请输入来电人员名称', trigger: 'input' },
          callerTime:{ required: true,message: this.$t('请选择系统登录账号'), trigger: 'change' },
        }
      },
    },
    methods: {
      hotlineStaffChange(e){
        var current = this.candidateUsersList.find(item=>item.id == e);
        this.$set(this.model,'hotlineStaffName',current.hotlineStaffName);
      },
      getUserList(){
        getAction(this.url.userList,{pageSize:999}).then(res=>{
          if(res.success){
            this.candidateUsersList = res.result.records;
          }
        })
      },
      init(row,type){
        this.visible = true;
        if(type == 'add'){
          this.title = this.$t('新增');
          this.disableSubmit = false;
        }else if(type == 'edit'){
          this.title = this.$t('编辑');
          this.disableSubmit = false;
        }else if(type == 'detail'){
          this.title = this.$t('详情');
          this.disableSubmit = true;
        }else{
          this.title = this.$t('回访');
          this.disableSubmit = false;
        }
        this.model = Object.assign({},row);
        this.getUserList();
      },
      handleCancel() {
        this.visible = false;
      },
      handleOk() {
        const that = this;
        // 触发表单验证
        this.$refs.form.validate(valid => {
          if (valid) {
            that.confirmLoading = true;
            let httpurl = '';
            if(that.model.id){
              httpurl+=this.url.edit;
            }else{
              httpurl+=this.url.add;
            }
            let params = that.model;
            postAction(httpurl,params).then((res) => {
              if (res.success) {
                that.$message.success(this.$t('操作成功'));
                that.$emit('ok');
                this.visible = false;
                that.confirmLoading = false;
              } else {
                that.$message.warning(res.message);
              }
            })
          }
        })
      },
    }
  }
</script>